import src from "IMAGE";
export default { src, width: 1096, height: 141, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AOHm6v/o6+7/6u3w/+3v8f/o7O//4+jr/+Hn6v/m6u3/7LYd51+pzmYAAAAASUVORK5CYII="};
